<div #desktopOffcanvas class="offcanvas offcanvas-end" tabindex="-1" [id]="content?.id"
    [attr.aria-labelledby]="(content?.id ||'offcanvas')+'Label'">
    <div class="offcanvas-header header-sec">
        <div class="heading">Your cover & benefits</div>
        <button type="button" id="btn_auxilaryButton_coverDrawer_close" name="btn_auxilaryButton_coverDrawer_close" class="btn-close text-reset pt-2" (click)="closeOffcanvas()"></button>
    </div>
    <div class="offcanvas-body px-3">
        <div class="block-sec">
            <div class="head text-start">Your policy benefits</div>
            <div class="divider_yellow"></div>
            <ul>
                <li>This Policy insures the <span class="font-weight-bold">insured lives </span>
                    under the Policy against the <span class="font-weight-bold">risk of death.</span>
                </li>
                <div class="border-li"></div>
                <li>If an insured life dies, we will pay out the
                    <span class="font-weight-bold">Insured Sum</span> , subject to age limitations.
                </li>
                <div class="border-li"></div>
                <li>If <span class="font-weight-bold">you</span> die, we will pay it to <span
                        class="font-weight-bold">your estate</span> or <span class="font-weight-bold">your appointed
                        beneficiary.</span> If <span class="font-weight-bold">another</span> member of the Policy dies,
                    we will
                    pay it out to <span class="font-weight-bold">you.</span>
                </li>
                <div class="border-li"></div>
                <li>Maximum number of insured lives: 
                    <span class="font-weight-bold">6</span>
                </li>
                <div class="border-li"></div>
                <li>Your Policy ends on the 
                    <span class="font-weight-bold">date of death </span>of the main insured life. 
                </li>
            </ul>
        </div>
        <div class="block-sec">
            <div class="head text-start">Your cover</div>
            <div class="divider_yellow"></div>
            <ul class="policy-list">
                <li>Insured Sum: <span class="font-weight-bold">R {{PolicyDetailResponse?.insuredSum?? 0 | number:'1.0-2'}}</span>
                </li>
            </ul>
        </div>
        <div class="block-sec">
            <div class="head text-start">Limitations & exclusions</div>
            <div class="divider_yellow"></div>
            <ul>
                <li>Age Limitations: Beneficiaries cannot be below the age of <span class="font-weight-bold">18.</span>
                </li>
                <div class="border-li"></div>
                <li>Maximum Insured Sums:
                    <ul>
                        <li>
                            <span class="font-weight-bold">Members under 6 years old: </span>
                            R10,000
                        </li>
                        <li>
                            <span class="font-weight-bold">Members between 6 and 14 years old: </span>R20,000
                        </li>
                    </ul>
                </li>
                <div class="border-li"></div>
                <li>Termination of Benefits: This benefit terminates when you turn <span class="font-weight-bold">99. </span>
                </li>
                <div class="border-li"></div>
                
                <li>Waiting Periods:
                    <ul>
                        <li>
                            <span class="font-weight-bold">Only natural death: </span>
                            6 months from the start of the Policy less any waiting period served under an
                            existing funeral policy.
                        </li>
                    </ul>
                </li>
                <div class="border-li"></div>
                
                <li>Exclusions: We will not pay a claim if the insured life’s death is:
                    <ul>
                        <li>
                            Caused by self-harm, criminal acts, unscheduled
                            flights, war, dangerous activities, alcohol or drugs or by not following prescribed medical treatment.
                        </li>
                        <li>
                            For the first
                            12 months of the Policy (less any waiting period served under an existing funeral policy), caused by suicide.
                        </li>
                    </ul>

                </li>
            </ul>
        </div>
        <div class="block-sec-footer">
            Individually issued policy document T&C's take precedence over the generalised information provided in your
            insurance
            summary.
        </div>
    </div>
</div>